import React from "react";
import "./support.scss";
import { Element } from "react-scroll";
import { Link } from "react-scroll";
import { NavLink } from "react-router-dom";
const Ourfeatures = () => {
  return (
    <>
      <div className="maincontent">
        <div className="innercontent">
          <div>
            <h1 className="mainhead">Our Features</h1>
            <Element name="featureone">
              <h4 className="midhead">Awesome Feature One</h4>
              <p className="mainpara">
                Get amazing things done with awesome feature one. But remember
                that awesome feature two and three exist too. In fact, Awesome
                Product is full of awesome features.
              </p>
              <div className="featureimg">
                <img src="/assets/featureone.jpeg" alt="innerimg" className="innerimg" />
              </div>
            </Element>
            <Element name="featuretwo">
              <h4 className="midhead">Awesome Feature Two</h4>
              <p className="mainpara">
              Get amazing things done with awesome feature two. But remember that awesome feature one and three exist too. In fact, Awesome Product is full of awesome features.
              </p>
              <div className="featureimg">
                <img src="/assets/featuretwo.jpeg" alt="innerimg" className="innerimg" />
              </div>
            </Element>
          </div>
    <div className="bottom-btns">
              <NavLink exact to="/support/whatwedo" className="innerbtn firstbtn">
                <div className="leftbtn">
                  <p className="innerbtnpara">Overview - Previous</p>
                  <p className="innerbtnhead">What we do</p>
                </div>
                <span className="arrowmain">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="15"
                    viewBox="0 0 14 15"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M9.06049 4.55397L9.37832 4.23613L8.74265 3.60046L8.42482 3.9183L5.05367 7.28944L4.73584 7.60728L5.05367 7.92511L5.34095 8.21239L6.34791 7.26654L9.06049 4.55397ZM6.26778 7.86788L6.02193 8.89337L8.42482 11.2963L8.74265 11.6141L9.37832 10.9784L9.06049 10.6606L6.26778 7.86788Z"
                      fill="#0E1120"
                    />
                  </svg>
                </span>
              </NavLink>
              <NavLink exact to="/support/gettingstarted" className="innerbtn">
                <div className="leftbtn">
                  <p className="innerbtnpara">Next - Fundamentals</p>
                  <p className="innerbtnhead">Getting Started</p>
                </div>
                <span className="arrowmain">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="15"
                    viewBox="0 0 14 15"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M9.06049 4.55397L9.37832 4.23613L8.74265 3.60046L8.42482 3.9183L5.05367 7.28944L4.73584 7.60728L5.05367 7.92511L5.34095 8.21239L6.34791 7.26654L9.06049 4.55397ZM6.26778 7.86788L6.02193 8.89337L8.42482 11.2963L8.74265 11.6141L9.37832 10.9784L9.06049 10.6606L6.26778 7.86788Z"
                      fill="#0E1120"
                    />
                  </svg>
                </span>
              </NavLink>
            </div>
        </div>
        <div className="right-sidebar">
          <div className="main-heading">
            <span>On this page</span>
          </div>
          <div className="rightlinks">
            <Link
              to="featureone"
              activeClass="active-link"
              spy={true}
              smooth={true}
              duration={300}
            >
      Awesome Feature One
            </Link>
            <Link
              to="featuretwo"
              activeClass="active-link"
              spy={true}
              smooth={true}
              duration={300}
            >
           Awesome Feature Two
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Ourfeatures;
